(function () {
    if (window.__cvpHoverPreviewInstalled) return;
    window.__cvpHoverPreviewInstalled = true;

    var PREVIEW_SIZE = 220;
    var HIRES_WIDTH = 1000;
    var BORDER_COLOR = '#262967';
    var hiresCache = {};
    var bound = new WeakSet();

    function formatMoney(cents) {
        var amount = (cents / 100).toFixed(2);
        return '$' + amount;
    }

    function ensurePreview(container, isDialog) {
        var preview = document.getElementById('cvp-swatch-hover-preview');
        if (!preview) {
            preview = document.createElement('div');
            preview.id = 'cvp-swatch-hover-preview';

            var imgWrap = document.createElement('div');
            imgWrap.id = 'cvp-swatch-hover-imgwrap';
            imgWrap.style.cssText =
                'width:100%;height:100%;border-radius:8px;overflow:hidden;' +
                'box-shadow:0 8px 24px rgba(0,0,0,0.25);background:#fff;' +
                'border:4px solid ' + BORDER_COLOR + ';box-sizing:border-box;';
            var img = document.createElement('img');
            img.style.cssText = 'display:block;width:100%;height:100%;object-fit:contain;background:#fff;';
            imgWrap.appendChild(img);
            preview.appendChild(imgWrap);

            var priceLabel = document.createElement('div');
            priceLabel.id = 'cvp-swatch-hover-price';
            priceLabel.style.cssText =
                'position:absolute;left:50%;bottom:100%;transform:translateX(-50%);margin-bottom:12px;' +
                'background:' + BORDER_COLOR + ';color:#fff;' +
                'font-family:inherit;font-weight:600;font-size:19.5px;line-height:1;padding:9px 15px;' +
                'border-radius:999px;box-shadow:0 2px 6px rgba(0,0,0,0.2);display:none;white-space:nowrap;';
            preview.appendChild(priceLabel);
        }
        preview.style.cssText =
            'position:' + (isDialog ? 'absolute' : 'fixed') + ';z-index:99999;pointer-events:none;opacity:0;' +
            'width:' + PREVIEW_SIZE + 'px;height:' + PREVIEW_SIZE + 'px;';
        if (preview.parentNode !== container) {
            container.appendChild(preview);
        }
        return preview;
    }

    function hiresUrl(src) {
        if (!src) return null;
        var url = src;
        if (url.indexOf('//') === 0) url = 'https:' + url;
        var widthRe = /([?&])width=[0-9]+/i;
        if (widthRe.test(url)) {
            url = url.replace(widthRe, '$1width=' + HIRES_WIDTH);
        } else {
            url += (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + HIRES_WIDTH;
        }
        return url;
    }

    function preload(url) {
        if (!url || hiresCache[url]) return;
        var pre = new Image();
        pre.onload = function () { hiresCache[url] = true; };
        pre.src = url;
    }

    function getPriceCents(swatchEl) {
        var priceEl = swatchEl.querySelector('[data-price-cents]');
        if (!priceEl) return 0;
        var cents = parseInt(priceEl.getAttribute('data-price-cents') || '0', 10);
        return isNaN(cents) ? 0 : cents;
    }

    function showPreviewFor(swatchEl, imgEl) {
        if (!imgEl || !imgEl.src) return;

        var dialogEl = swatchEl.closest('dialog');
        var container = dialogEl || document.body;
        var isDialog = !!dialogEl;
        var preview = ensurePreview(container, isDialog);
        var pImg = preview.querySelector('img');
        var priceLabel = preview.querySelector('#cvp-swatch-hover-price');
        var url = hiresUrl(imgEl.src);

        pImg.setAttribute('data-target', url);
        if (hiresCache[url]) {
            pImg.src = url;
        } else {
            pImg.src = imgEl.src;
            preload(url);
            var check = new Image();
            check.onload = function () {
                if (pImg.getAttribute('data-target') === url) {
                    pImg.src = url;
                }
            };
            check.src = url;
        }

        var cents = getPriceCents(swatchEl);
        if (cents > 0) {
            priceLabel.textContent = formatMoney(cents);
            priceLabel.style.display = 'block';
        } else {
            priceLabel.style.display = 'none';
        }

        var anchorEl = imgEl.closest('.atlas-cvp__swatch-visual, .atlas-cvp__table-thumb') || imgEl;
        var rect = anchorEl.getBoundingClientRect();

        if (isDialog) {
            var containerRect = container.getBoundingClientRect();
            var relLeft = rect.left - containerRect.left + container.scrollLeft;
            var relTop = rect.top - containerRect.top + container.scrollTop;
            var left = relLeft + rect.width / 2 - PREVIEW_SIZE / 2;
            left = Math.max(8, Math.min(left, container.scrollWidth - PREVIEW_SIZE - 8));
            var top = relTop - PREVIEW_SIZE - 12;
            if (top < container.scrollTop + 8) top = relTop + rect.height + 12;
            preview.style.left = left + 'px';
            preview.style.top = top + 'px';
        } else {
            var left = rect.left + rect.width / 2 - PREVIEW_SIZE / 2;
            left = Math.max(8, Math.min(left, window.innerWidth - PREVIEW_SIZE - 8));
            var top = rect.top - PREVIEW_SIZE - 12;
            if (top < 8) top = rect.bottom + 12;
            if (top + PREVIEW_SIZE > window.innerHeight - 8) {
                top = Math.max(8, window.innerHeight - PREVIEW_SIZE - 8);
            }
            preview.style.left = left + 'px';
            preview.style.top = top + 'px';
        }

        preview.style.opacity = '1';
    }

    function hidePreview() {
        var preview = document.getElementById('cvp-swatch-hover-preview');
        if (preview) preview.style.opacity = '0';
    }

        var SWATCH_SEL = '.atlas-cvp__swatch, .atlas-cvp__ft-swatch, .atlas-cvp__multiqty-item, .atlas-cvp__step:not([data-step-type="swatch-table-text"]) .atlas-cvp__table-row';

    function bindOne(swatchEl) {
        if (bound.has(swatchEl)) return;
        var imgEl = swatchEl.querySelector('img');
        if (!imgEl) return;

        bound.add(swatchEl);

        if (imgEl.src) preload(hiresUrl(imgEl.src));
        if (imgEl.complete === false) {
            imgEl.addEventListener('load', function () { preload(hiresUrl(imgEl.src)); }, { once: true });
        }

        imgEl.addEventListener('pointerenter', function () {
            var currentImg = swatchEl.querySelector('img') || imgEl;
            showPreviewFor(swatchEl, currentImg);
        });
        imgEl.addEventListener('pointerleave', function () {
            hidePreview();
        });
    }

    function scanAndBind() {
        document.querySelectorAll(SWATCH_SEL).forEach(bindOne);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { setTimeout(scanAndBind, 300); });
    } else {
        setTimeout(scanAndBind, 300);
    }
    var _cvpObserver = new MutationObserver(function () {
        clearTimeout(window.__cvpScanDebounce);
        window.__cvpScanDebounce = setTimeout(scanAndBind, 200);
    });
    _cvpObserver.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('scroll', hidePreview, true);
})();